











































import {Vue, Component, Watch} from 'vue-property-decorator';
import { loadModules } from 'esri-loader';
import { arcgisConfig } from '@/config';
import LocaBasemap from '../utils/local_basemap';
import StreetView from './StreetView.vue';
import WMSServices from '@/components/WMSServices.vue';
import UtmLatLng from 'utm-latlng';

const arcgisModules = loadModules([
    // Geometry
    "esri/geometry/Extent",
], arcgisConfig.loaderOptions).then( ([
      Extent
  ]) => {
    return {
      Extent
    };
});

@Component({
    components: {
        WMSServices,
        StreetView,
    },
})
export default class EsriMap extends Vue {
    public widgetDireXY:any
    public widgetAaveXY:any
    public widgetInfoXY:any
    public widgetMedirL:any
    public widgetMedirA:any

    private widgets = [   
    ];
    private widgetsVertical = [
        { ref: 'basemap-gallery', icon: 'esri-icon-basemap', title: 'Galería de Mapas Base'},
        { ref: 'layers-list', icon: 'esri-icon-layers', title: 'Selector de Capas'},
        { ref: 'layers-legend', icon: 'esri-icon-legend', title: 'Leyenda'},
        { ref: 'zoom-full', icon: 'esri-icon-globe', title: 'Extensión Perú'},
        { ref: '3d-2d', icon: 'esri-icon-media', title: '3D'},
        { ref: 'street-view', icon: 'street-view-icon', title: 'StreetView'},
        //{ ref: 'add-wms', icon: 'esri-icon-plus', title: 'Add WMS'},
        //{ ref: 'mesurement', icon: 'mesurement-icon', title: 'Realizar Mediciones'},
        
    ];
    private currentEvent = {widget:'',
                            estado:false};
    private currentWidget = '';
    private OpenWidget:any = {ref:''};
    private mesurementWidget!:any;
    private mesurementAreaWidget!:any;
    public view:any = {};
    public scene:any = {};
    public appConfig = {
          mapView: null as any,
          sceneView: null as any,
          activeView:null as any,
          container:null as any
    };

    private oExtent = {"xmin":-81.99,"ymin":-22.10,"xmax":-68.65,"ymax":4.25,"spatialReference":{"latestWkid":3857,"wkid":4326}}

    private utmConverter = new UtmLatLng();
    private coordinates = {
        latitude: '',
        longitude: '',
        easting: '',
        northing: '',
        zone: '',
    };
    @Watch('currentWidget')
    private onCurrentWidgetChange(newWidget:string, lastWidget:string){
        if (lastWidget === 'mesurement'){
            this.mesurementWidget && this.mesurementWidget.viewModel.clearMeasurement();
            this.mesurementAreaWidget && this.mesurementAreaWidget.viewModel.clearMeasurement();
        }
    }

    private mounted() {
        this.initMap();
    }

    // Computed Properties
    private get currentView(){
        return this.view;
    }

    // Methods
    openWidget(widget: any) {
      //--Cargamos la Libreria
      switch (widget.ref) {
          case "zoom-full":
              this.setFullExtent();
              break;
          case "3d-2d":
              this.setChangeView();
              break;              
           default:
            this.OpenWidget = widget;
            this.currentWidget = widget.ref;
        }
    }

    async setFullExtent(){
        //--Cargamos la Libreria
        const {Extent} = await arcgisModules;
        this.view.extent =new Extent(this.oExtent) 
    }
    
    setChangeView(){
        const is3D = this.appConfig.activeView.type === "3d";
        const activeViewpoint = this.appConfig.activeView.viewpoint.clone();
        this.appConfig.activeView.container = null;
        const switchButton:any = document.getElementById("btn3d-2d");
        const switchImagen:any = document.getElementById("esri-icon-media");
        
        console.log(switchButton)
        if (!is3D) {
            this.appConfig.sceneView.viewpoint = activeViewpoint;
            this.appConfig.sceneView.container = this.appConfig.container;
            this.appConfig.activeView = this.appConfig.sceneView;
            switchImagen.className = "esri-icon-maps";
            switchButton.title = "2D";
        }else{
            this.appConfig.mapView.viewpoint = activeViewpoint;
            this.appConfig.mapView.container = this.appConfig.container;
            this.appConfig.activeView = this.appConfig.mapView;
            switchImagen.className = "esri-icon-slice";
            switchButton.title = "3D";
        }
    }

    public closeWidget() {
        this.currentWidget = '';
    }

    private updateCoordinates(evt:any){

        const mapPoint = this.view.toMap({x: evt.x, y: evt.y});
        const pointUTM = this.utmConverter.convertLatLngToUtm(mapPoint.latitude, mapPoint.longitude, 2)

        this.coordinates.latitude  = mapPoint.latitude.toFixed(6);
        this.coordinates.longitude  = mapPoint.longitude.toFixed(6);
        this.coordinates.easting  = pointUTM.Easting;
        this.coordinates.northing  = pointUTM.Northing;
        this.coordinates.zone  = pointUTM.ZoneNumber;
    }
    private onClickMap(evt:any){
        this.appConfig.activeView.popup.autoOpenEnabled = true;
        const mapPoint = this.appConfig.activeView.toMap({x: evt.x, y: evt.y});
        if (this.OpenWidget.ref == 'street-view'){
            this.view.popup.autoOpenEnabled = false;
        }else{
            this.$emit('AppViewEstXY',mapPoint);  
        }    
    }
    private initMap() {
        loadModules([
            'esri/Map',
            'esri/views/MapView',
            'esri/views/SceneView',
            'esri/layers/MapImageLayer',
            'esri/widgets/BasemapGallery',
            'esri/widgets/Legend',
            'esri/widgets/LayerList',
            'esri/widgets/Locate',
            'esri/widgets/Compass',
            'esri/widgets/DistanceMeasurement2D',
            'esri/widgets/AreaMeasurement2D',
            'esri/widgets/Measurement',
            'esri/widgets/Search',
            'esri/widgets/Expand',
            'esri/Basemap',
            'esri/layers/TileLayer',
            // Request
            "esri/request",
            ], arcgisConfig.loaderOptions)
        .then(([Map, MapView, SceneView, MapImageLayer, BasemapGallery, Legend, LayerList, Locate, Compass, DistanceMeasurement2D, AreaMeasurement2D,Measurement, Search, Expand, Basemap, TileLayer, esriRequest]) => {
            // create map with the given options at a DOM node w/ id 'mapNode'
            const map = new Map({
                basemap: new Basemap({id: 'topo',
                                      baseLayers: [new TileLayer({
                                        url: 'http://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer',
                                        //displayLevels: [0, 1, 2, 3, 4, 5, 6, 7,8, 9, 10, 11],
                                        minScale:3000001,
                                        isReference: true,
                                        }),
                                        new TileLayer({
                                        url: 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer',
                                        //displayLevels: [ 12, 13, 14, 15],
                                        maxScale:3000000,
                                        isReference: true,
                                        })]
                                     }),
                ground: "world-elevation"
            });
            //--3D
            const scene = new SceneView({
                container: null,
                map,
		        extent: this.oExtent,
            });

            //--2D
            const view = new MapView({
                container: this.$refs['map-view'],
                map,
                extent: this.oExtent,
            });
            //--Switch 3D/2D
            this.appConfig.mapView = view;
            this.appConfig.sceneView = scene;
            this.appConfig.activeView = view;
            this.appConfig.container = this.$refs['map-view'];

            view.on('pointer-move', this.updateCoordinates);
            view.on('click',this.onClickMap);
            scene.on('click',this.onClickMap);

            //--Evento que se ejecuta al cargar todos los capas
            map.lyrInMap = []; 
            view.when(() => {
                //--Invocamos a la función que se encuentra en el Padre App
                this.$emit('EventLoadMapComplete');
                this.setFullExtent();
                map.layers.items.forEach(function(item:any, index:any){
                    //--Nos Aseguremoas que el Layer este Cargado
                    if (item.title =='Vigilancia Ambiental'){
                        console.log(item.title);
				        item.when(function() {
                            item.allSublayers.forEach(function(itemLyr:any, index:any){
                                let _lyr:any = {}; 
					    		_lyr.title = itemLyr.title;
                                _lyr.layer = itemLyr;
                                map.lyrInMap.push(_lyr)

                                //--Cargamos la opción de Identify
                                esriRequest(itemLyr.url + '?f=json',{
                                    responseType: "json"})
                                .then(function(r:any){
                                    let popupContent = {title: "{NOMB_ESTACION}{ESTACION}", 							
                                                        content:[{ type: "fields",fieldInfos: [] as any},{type: "media", mediaInfos: []}] as any
                                                       };
                                    if (r.data.fields != null){                                             
					    		        r.data.fields.forEach(function (field:any){
					    			        if (field.type !== 'esriFieldTypeOID'  && field.type !== 'esriFieldTypeGeometry' && 
					    			            field.type !== 'esriFieldTypeBlob' && field.type !== 'esriFieldTypeRaster'   &&
					    			         field.type !== 'esriFieldTypeGUID' && field.type !== 'esriFieldTypeGlobalID' && 
					    			         field.type !== 'esriFieldTypeXML') {  
                                                if (field.alias.toUpperCase().substr(0, 10)=='FOTOGRAFÍA') {
                                                    popupContent.content[1].mediaInfos.push({
                                                        type: "image",  
                                                        title: field.alias,
                                                        value: {sourceURL: '{' + field.name + '}'}                                        
                                                    });
                                                }else if (field.alias.toUpperCase() !='OBJECTID') {
                                                    popupContent.content[0].fieldInfos.push({
                                                        fieldName: field.name, 
                                                        visible: true,  
                                                        label: field.alias + ': '  
                                                     });
							                    }
					    			        }  
                                        });
                                    }
                                    if (!itemLyr.popupTemplate) {
							            itemLyr.popupTemplate = popupContent;  	
						            }
                                });
                            });
                        });
                    }      
                });
            });

            // Add data to map
            const serviceArray = arcgisConfig['servicio-arcgis']["servicios"];
            const layers = serviceArray.map( item => {
                return new MapImageLayer({
                    url: `${item.url}/${item.servicio}/MapServer`,
                    id: item.servicio,
                    title: item.titulo,
                    visible:item.visible,
                });
            });
            // Add Services
            map.addMany(layers);
            //Desactivamos el boton de información
            view.popup.autoOpenEnabled = false;
            
            //--Agregamos Widget Esri Personalizados
            const basemapGallery = new BasemapGallery({
                view,
                container: 'basemap-gallery',
                source: LocaBasemap.getbasemapslocalSource(),
            });
            const legend = new Legend({
                view,
                container: 'layers-legend'
            });

            this.mesurementWidget = new DistanceMeasurement2D({
                view,
                container: 'distance-mesurement',
            });
            this.mesurementAreaWidget = new AreaMeasurement2D({
                view,
                container: 'area-mesurement',
            });         

            // Agregamos los Widgets de Esri
            const layerList = new LayerList({view, container: 'layers-list'});

            const locateWidget = new Locate({view});
            view.ui.add(locateWidget, 'top-left');

            const compass = new Compass({view});
            view.ui.add(compass, 'top-left');
            this.view = view;
        })
        .catch((err) => {
            // handle any script or module loading errors
            console.error(err);
        });
    }
}
